// extracted by mini-css-extract-plugin
module.exports = {"container":"with-accordion_container__1pSlP","label":"with-accordion_label__EvG72","label-active":"with-accordion_label-active__32tK5"};